import React, { useEffect } from 'react';

import { Avatar, TextField } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useField } from 'formik';

import AvatarComponent from '~/components/Avatar';

import { Container, AvatarComponentContainer } from './styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
      zIndex: 99999,
    },
    input: {
      padding: 0,
      zIndex: 99999,
    },

    noLabel: {
      marginTop: theme.spacing(3),
      zIndex: 99999,
    },
    root: {
      zIndex: 99999,
      width: 318,
    },

    popper: {
      zIndex: 99999,
    },
  }),
);

export interface SelectProps {
  name: string;
  label?: string;
  options?: any;
  clearField: boolean;
}

export default function SelectWithAvatar({
  name,
  options,
  clearField,
}: SelectProps) {
  const classes = useStyles();

  const [field, meta, helpers] = useField<any>(name);
  const { value: selectedValue } = field;
  const { setValue } = helpers;

  useEffect(() => {
    if (clearField) {
      setValue([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearField]);

  return (
    <Container>
      <FormControl className={classes.formControl}>
        <FormControl className={(classes.formControl, classes.input)}>
          <p style={{ margin: '0 0 4px' }}>Responsável</p>

          <Autocomplete
            classes={classes}
            multiple
            noOptionsText="Usúario não encontrado"
            options={options}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(value) =>
              value.label === selectedValue[0]?.label
            }
            value={selectedValue}
            onChange={(event, newValue) => {
              if (newValue.length >= 2) {
                newValue.shift();
              }
              setValue(newValue);
            }}
            renderOption={(props, option: any) => (
              <AvatarComponentContainer>
                <li {...props}>
                  {props.value.thumbnail ? (
                    <Avatar
                      src={props.value.thumbnail}
                      style={{
                        width: '32px',
                        height: '32px',
                      }}
                    />
                  ) : (
                    <AvatarComponent
                      name={`${props.value.firstName} ${props.value.lastName}`}
                      size={32}
                    />
                  )}
                  <span>{props.label}</span>
                </li>
              </AvatarComponentContainer>
            )}
            renderTags={(value: readonly any[]) =>
              value.map((option: any, index: number) => (
                <Chip
                  avatar={
                    option.value.thumbnail ? (
                      <Avatar src={option.value.thumbnail} />
                    ) : (
                      <AvatarComponent name={option.label} size={26} />
                    )
                  }
                  style={{ background: '#F4F4F4' }}
                  variant="default"
                  label={option.label}
                  title={option.label}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                className="text-field"
                autoFocus={false}
                placeholder={
                  selectedValue?.length === 0 ? 'Nome do responsável' : ''
                }
                variant="outlined"
                {...params}
                style={{ padding: 0 }}
              />
            )}
          />
        </FormControl>
      </FormControl>
    </Container>
  );
}
